const deleteCollectionDocument = async (collectionRef, docId) => {
  await collectionRef.doc(docId).delete();
};
export default deleteCollectionDocument;
